import { onMounted, onBeforeUnmount } from 'vue'

/**
 * Déclenche un callback quand un clic se produit en dehors de l'élément référencé.
 * @param {import('vue').Ref<HTMLElement | null>} elementRef
 * @param {(event: MouseEvent) => void} handler
 */
export function useClickOutside(elementRef, handler) {
  function onDocumentClick(event) {
    const el = elementRef.value
    if (el && !el.contains(event.target)) {
      handler(event)
    }
  }

  onMounted(() => document.addEventListener('click', onDocumentClick))
  onBeforeUnmount(() => document.removeEventListener('click', onDocumentClick))
}
